export enum LanguageEnum {
    english,
    russian,
    armenian,

    'en' = LanguageEnum.english,
    'ru' = LanguageEnum.russian,
    'hy' = LanguageEnum.armenian
}